import { Middleware } from 'redux'
import { RootState } from '../modules/rootReducer'
import { StudyPlanActionTypes } from '../modules/studyPlan/types'
import { resetTimer } from '../modules/timer/actions'

/**
 * Middleware que protege mudanças de plano quando o timer está ativo
 * Se o timer estiver rodando, pausado ou encerrado mas ainda visível e o usuário tentar mudar o plano,
 * reseta o timer antes de permitir a mudança
 */
export const timerGuardMiddleware: Middleware<any, RootState> = (store) => (next) => (action) => {
  // Intercepta apenas a ação de mudar plano atual
  if (action.type === StudyPlanActionTypes.SET_CURRENT_PLAN) {
    const state = store.getState()
    const timerState = state.timer

    // Verifica se o timer está ativo (running, paused ou stopped e visível)
    const isTimerActive =
      timerState.status === 'running' ||
      timerState.status === 'paused' ||
      (timerState.status === 'stopped' && timerState.isVisible)

    // Se o timer está ativo e o plano está mudando (não é null e é diferente do atual)
    if (
      isTimerActive &&
      action.payload !== null &&
      action.payload !== state.studyPlan.currentPlanId
    ) {
      // Reseta o timer antes de permitir a mudança
      store.dispatch(resetTimer())
    }
  }

  return next(action)
}
